export const events = {
    title: {
        charsRemaining: 24
    }
};

export const login = {
    email: {
        isValidEmail: true
    }
};


// WEBPACK FOOTER //
// ./src/constants/validationWarningRules.js